import * as React from 'react';

import CourseraPlusWelcomeNotification from 'bundles/coursera-plus/components/lihp/CourseraPlusWelcomeNotification';
import CourseraPlusMonthlyToAnnualUpgradeNotification from 'bundles/coursera-plus/components/monthlyToAnnualUpgrade/CourseraPlusMonthlyToAnnualUpgradeNotification';

const CourseraPlusNotificationsContainer = () => (
  <>
    <CourseraPlusMonthlyToAnnualUpgradeNotification />
    <CourseraPlusWelcomeNotification />
  </>
);

export default CourseraPlusNotificationsContainer;
